import styled from '@emotion/styled';
import { MediumFontWeight } from '../../../../components/ui/fonts';

export const SlicerErrorDialogTitle = styled.span({
  fontWeight: MediumFontWeight,
});

export const MobileErrorWrapper = styled.div({ padding: '5px 10px' });
